<link rel="ractive" href="../r-page.html">
<link rel="ractive" href="../components/header.html" name="c-header">
<link rel="ractive" href="../components/footer.html" name="c-footer">
<link rel="ractive" href="../components/header-gradient.html" name="c-header-gradient">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<c-header useWhiteLogos="true" additionalClasses="header-with-orange-bg"></c-header>

	<div class="p-github">
		<c-header-gradient showMap="{{ true }}"></c-header-gradient>

		<div class="content">
			<div class="title">
				<h1>Migrating from GitHub to jsDelivr</h1>

				<h2>
					jsDelivr is a free, fast, and reliable Open Source CDN for npm and GitHub.
					Most GitHub links can be easily converted to jsDelivr links.
				</h2>
			</div>

			<div class="container">
				<div class="box">
					<div class="bar {{#if out && !error}}bar-active{{/if}}">
						<div class="circle"></div>
						<div class="line {{#if out && !error}}filled{{/if}}"></div>
						<div class="circle bottom {{#unless out && !error}}circle-disabled{{/unless}}"></div>
					</div>

					<div class="icon-competitor">
						<img width="84" height="30" src="{{@shared.assetsHost}}/img/github.svg">
					</div>

					<div class="input-wrapper mb-48">
						<input type="text" class="input {{#if out}}active{{/if}}" placeholder="Paste a GitHub link here" value="{{in}}">
					</div>

					<div class="icon-jsdelivr">
						<img width="115" height="28" src="{{@shared.assetsHost}}/img/jsDelivr.logo.svg">
					</div>

					<div class="input-wrapper">
						<input type="text" class="input {{#if out && !error}}input-jsdelivr-copy{{/if}} {{#if out}}active{{/if}}" placeholder="Get a jsDelivr link here" value="{{out}}">

						{{#if out && !error}}
							<a class="copy" as-clipboard data-clipboard-text="{{out}}">Copy</a>
						{{/if}}
					</div>

					{{#if displayHtmlWarning}}
						<div class="alert alert-warning" role="alert">
							For security reasons, we serve HTML files with <code>Content-Type: text/plain</code>.
							We recommend using <a href="https://pages.github.com/" target="_blank" rel="noopener noreferrer">GitHub Pages</a> if this is a problem.
						</div>
					{{/if}}
				</div>

				<div class="host-descr-title">
					jsDelivr is a free CDN (Content Delivery Network)
					<br />
					for open source files
				</div>

				<div class="host-descr-text">
					By using jsDelivr CDN URLs you get better performance globally thanks to our multi-CDN infrastructure. We also permanently cache all files to ensure reliability, even if your files get deleted from GitHub they will continue to work on jsDelivr without breaking any sites using them. The jsDelivr CDN is designed for production use with multiple layers of failover to ensure best possible uptime.
				</div>

				<div class="buttons">
					<a href="/" class="all-features">See All Features</a>
				</div>
			</div>
		</div>
	</div>

	<c-footer></c-footer>
</r-page>

<script>
	/* eslint-disable no-throw-literal */

	const debounce = require('../../assets/js/utils/debounce');
	const throttle = require('../../assets/js/utils/throttle');
	const clipboard = require('../../assets/js/decorators/clipboard');
	const defaultError = 'Sorry, this doesn\'t look like a valid GitHub link :(';
	const _ = require('../../assets/js/_');

	component.exports = {
		decorators: {
			clipboard,
		},
		data () {
			return {
				title: 'Migrate from GitHub to jsDelivr',
				description: 'Migrate from GitHub to jsDelivr - a free, fast, and reliable Open Source CDN optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.',
			};
		},
		oninit () {
			let buildJsDelivrLink = (user, repo, version, path) => {
				if (version === 'latest') {
					return `https://cdn.jsdelivr.net/gh/${user}/${repo}/${path}`;
				}

				return `https://cdn.jsdelivr.net/gh/${user}/${repo}@${version}/${path}`;
			};

			let isCommitPrefixOrTag = (user, repo, sha) => {
				return _.makeHTTPRequest({ url: `https://api.github.com/repos/${user}/${repo}/commits/${sha}` }).then((response) => {
					return response.sha.indexOf(sha) === 0 ? response.sha : sha;
				}).catch(() => {
					return false;
				});
			};

			let gitHub2jsDelivr = gitHub => Promise.resolve().then(() => {
				let pattern = /^https?:\/\/(?:github|raw\.githubusercontent)\.com\/([^/]+)\/([^/]+)(?:\/(?:blob|raw))?(?:\/([^/]+))?(?:\/(.*))?\/?$/i;
				let commitPattern = /^[0-9a-f]{40}$/;
				let match = pattern.exec(gitHub);

				if (match) {
					let [ , user, repo, version, file ] = match;

					if (!version || !file) {
						return `https://cdn.jsdelivr.net/gh/${user}/${repo}/`;
					}

					// full commit hash
					if (commitPattern.test(version)) {
						return buildJsDelivrLink(user, repo, version, file);
					}

					// tag/commit prefix
					return isCommitPrefixOrTag(user, repo, version).then((sha) => {
						if (sha) {
							return buildJsDelivrLink(user, repo, sha, file);
						}

						// branch
						return buildJsDelivrLink(user, repo, version, file);
					});
				}

				throw defaultError;
			});

			this.observe('in', debounce(throttle((gitHub) => {
				this.set('displayHtmlWarning', /\.html?$/i.test(gitHub));

				if (!gitHub) {
					return this.set('out', '');
				}

				gitHub2jsDelivr(gitHub).then((jsDelivr) => {
					this.set('error', false);

					if (this.get('in') === gitHub) {
						this.set('out', jsDelivr);
					}
				}).catch((error) => {
					this.set('error', true);
					this.set('out', typeof error === 'string' ? error : defaultError);
				});
			}, 1000)));
		},
	};
</script>
